import { render } from "./IncassiPagamentiSottoProgetto.vue?vue&type=template&id=c74dd6c8&scoped=true&ts=true"
import script from "./IncassiPagamentiSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./IncassiPagamentiSottoProgetto.vue?vue&type=script&lang=ts"

import "./IncassiPagamentiSottoProgetto.vue?vue&type=style&index=0&id=c74dd6c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74dd6c8"]])

export default __exports__